import React, { useState, useEffect, useContext, useRef } from 'react';
import './AlarmHistory.css';
import convenienceApi from '../../common/api/convenience';
import Card from '../Card/Card';
import CardContent from '../Card/CardContent';
import CardLink from '../Card/CardLink';
import CardLinkReport from '../Card/CardLinkReport';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { CardAlarmHistoryContext } from '../../contexts/CardAlarmHistoryContext';
import AlarmHistoryContent from './AlarmHistoryContent';
import AlarmHistoryTimeRange from './AlarmHistoryTimeRange';
import AlarmHistoryLoadingStatus from './AlarmHistoryLoadingStatus';
import logComponent from '../../common/logComponent';


export default function AlarmHistory({ moduleDescription }) {
  const environmentContext = useContext(EnvironmentContext);
  //Note:  We are using context for data and time range because it wasn't updating the CardContent children when data changed or current time stamp changed
  const cardAlarmHistoryContext = useContext(CardAlarmHistoryContext);
  const { timeRanges } = cardAlarmHistoryContext;
  const [currentTimeRange, setCurrentTimeRange] = useState(timeRanges[0]);
  const { hasToken, activeUser: user, reportsEnabled } = environmentContext;
  const loadingRef = useRef(false);


  const setLoadingRef = (el) => {
    if (logComponent('AlarmHistory')) { console.debug('AlarmHistory setLoadingRef'); }
    loadingRef.current = el;
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('AlarmHistory')) {console.debug('AlarmHistory onMount'); }
    if (!hasToken) return;

    loadData();
  }, []);

  useEffect(() => {
    if (logComponent('AlarmHistory')) {console.debug('AlarmHistory useEffect [currentTimeRange ]'); }
    if (!hasToken) return;

    loadData();

  }, [currentTimeRange]);

  useEffect(() => {
    if (logComponent('AlarmHistory')) {console.debug('AlarmHistory useEffect [environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit ]'); }
    if (!hasToken) return;

    if (currentTimeRange !== timeRanges[0]) {
      updateTimeRange(timeRanges[0]);
    }
    else {
      loadData();
    }

  }, [environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit ]);

  const loadData = () => {
    if (logComponent('AlarmHistory')) {console.debug('AlarmHistory loadData'); }

    const { hasToken } = environmentContext;
    const { setAlarmHistory, setAlarmHistoryLoading, setAlarmHistoryError } = cardAlarmHistoryContext;
    if (!hasToken || loadingRef.current) return;
    setLoadingRef(true);

    let days = null;

    switch (currentTimeRange) {
      case 'Past 7 days':
        days = 7;
        break;
      case 'Past 30 days':
        days = 30;
        break;
      default:
        break;
    }

    if (!days) return;

    const { selectedMonitoredIndividual, selectedUnit, activeUser: user } = environmentContext;

    setAlarmHistory(null);
    setAlarmHistoryLoading(true);
    setAlarmHistoryError(false);


    convenienceApi.getAverageResponseData(days, user, selectedMonitoredIndividual, selectedUnit)
      .then(
        result => {
          setAlarmHistory(result);
          setAlarmHistoryLoading(false);
          setAlarmHistoryError(false);
          setLoadingRef(false);
       },
        error => {
          setAlarmHistory(null);
          setAlarmHistoryLoading(false);
          setAlarmHistoryError(true);
          setLoadingRef(false);
        }
    )
  }

  const updateTimeRange = (newRange) => {
    const { setAlarmHistoryTimeRange } = cardAlarmHistoryContext;
    setAlarmHistoryTimeRange(newRange);
    setCurrentTimeRange(newRange);
  }

  
  if (logComponent('AlarmHistory')) { console.debug('AlarmHistory rendered'); }


  return (
    <Card className="Alarm-History" title="Alarm history" moduleDescription={moduleDescription} icon="stopwatch">
      <CardContent >
        <AlarmHistoryTimeRange updateTimeRange={ updateTimeRange } />
        <AlarmHistoryContent />
        <AlarmHistoryLoadingStatus reloadAction={loadData} />
      </CardContent>
      {
        user.groupTypeString !== 'Family' && reportsEnabled &&
        <CardLink>
            <CardLinkReport reportId={4} />
        </CardLink>
      }
    </Card>
  );
}